let currentIdToken = "";

export const authTokenStore = {
  get(): string {
    return currentIdToken;
  },

  set(token: string): void {
    currentIdToken = token;
  },

  clear(): void {
    currentIdToken = "";
  },

  hasToken(): boolean {
    return currentIdToken.length > 0;
  },
};
